import styled from 'styled-components';

import { COLORS } from '@r1-frontend/ui-react/tokens/colors';
import { FONTS } from '@r1-frontend/ui-react/tokens/fonts';

export const CardWrapper = styled.div`
    display: flex;
    flex-direction: column;
    flex-wrap: nowrap;
    width: calc(100% - 20px);
    max-width: 300px;
    min-height: 371px;
    padding: 16px;
    border-radius: 16px;
    background: ${COLORS.BgMain};
`;

export const CardImg = styled.div`
    position: relative;
    width: 100%;
    height: 131px;
    background: none;
    margin-bottom: 12px;

    img {
        object-fit: contain;
        object-position: center;
        width: 80%;
        height: auto;
        margin: 0 auto;
    }
`;

export const CardTitle = styled.p`
    ${FONTS.L};
    margin-bottom: 6px;
    white-space: pre-wrap;
`;

export const CardDesc = styled.div`
    flex: 1 1 auto;
    ${FONTS.XS};
    white-space: pre-wrap;
    p {
        margin-top: 1.5em;
    }

    a {
        ${FONTS.MediumS};
        color: ${COLORS.Link};
        transition: 0.3s;

        &:hover {
            color: ${COLORS.Brand_Blue};
        }
    }
`;
